import { useRecoilValue } from "recoil";
import { permissionsSelector } from "modules/Login/selectors/permissionSelector";
import { PERMISSIONS } from "modules/PermissionsConstants";
import { HomeCompanyTable } from "./view/HomeCompanyTable";

interface Props {}

export const HomeCompany: React.FC<Props> = () => {
  const viewPermission =
    PERMISSIONS.permission_utilities_homecompany_type_view;
    const userPermissions = useRecoilValue(permissionsSelector);
  return (
    <> {userPermissions.includes(viewPermission) && <HomeCompanyTable />} </>
  );
};

export default HomeCompany;